import { initContract } from '@ts-rest/core'
import { z } from 'zod'
import { ErrorResponseSchema } from '../../../shared/types'
import { CatDtoSchema } from '../cats/cats.schemas'
import { DogDtoSchema } from '../dogs/dogs.schemas'

const c = initContract()

const options = {
  pathPrefix: '/animals',
  commonResponses: {
    400: ErrorResponseSchema,
    404: ErrorResponseSchema,
    500: ErrorResponseSchema,
  },
}

export const animalAnimalsContract = c.router({
  getAnimals: {
    method: 'GET',
    path: '',
    description: 'Get all animals (dogs and cats) for a user',
    query: z.object({ userId: z.string().uuid() }),
    responses: {
      200: z.object({
        dogs: DogDtoSchema.array(),
        cats: CatDtoSchema.array(),
      }),
    },
  },
  associate: {
    method: 'PUT',
    path: '/:animalId/users/:userId',
    pathParams: z.object({
      animalId: z.string().uuid(),
      userId: z.string().uuid(),
    }),
    body: c.noBody(),
    responses: {
      204: c.noBody(),
    },
  },
  createAnimalImage: {
    method: 'POST',
    path: '/:animalId/image',
    pathParams: z.object({
      animalId: z.string().uuid(),
    }),
    body: z.object({
      url: z.string(),
    }),
    responses: {
      204: c.noBody(),
    },
  },
  disassociate: {
    method: 'DELETE',
    path: '/:animalId/users/:userId',
    pathParams: z.object({
      animalId: z.string().uuid(),
      userId: z.string().uuid(),
    }),
    responses: {
      204: c.noBody(),
    },
  },
  delete: {
    method: 'DELETE',
    path: '/:animalId',
    pathParams: z.object({
      animalId: z.string().uuid(),
    }),
    responses: {
      204: c.noBody(),
    },
  },
  removeAnimalImage: {
    method: 'DELETE',
    path: '/:animalId/image',
    pathParams: z.object({
      animalId: z.string().uuid(),
    }),
    body: c.noBody(),
    responses: {
      204: c.noBody(),
    },
  },
}, options)
